/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/button.css'
import VanField from 'vant/es/field'
import 'vant/es/field/style/less'
import VanForm from 'vant/es/form'
import 'vant/es/form/style/less'


import { render, staticRenderFns } from "./contacts.vue.js?vue&type=template&id=47a911ef&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./contacts.vue?vue&type=template&id=47a911ef&scoped=true"
import script from "./contacts.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./contacts.vue?vue&type=script&setup=true&lang=js"
export * from "./contacts.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./contacts.vue?vue&type=script&setup=true&lang=js"
import style0 from "./contacts.vue.css?vue&type=style&index=0&id=47a911ef&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./contacts.vue?vue&type=style&index=0&id=47a911ef&prod&lang=css"
import style1 from "./contacts.vue.postcss?vue&type=style&index=1&id=47a911ef&prod&lang=postcss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./contacts.vue?vue&type=style&index=1&id=47a911ef&prod&lang=postcss&scoped=true"
import style2 from "./contacts.vue.css?vue&type=style&index=2&id=47a911ef&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./contacts.vue?vue&type=style&index=2&id=47a911ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a911ef",
  null
  
)

export default component.exports
installComponents(component, {VanButton,VanField,VanForm})
